import { __decorate, __metadata } from "tslib";
import { IsDefined, IsEnum, IsOptional, IsUUID } from 'class-validator';
import { UserGroupPermissionId } from './UserGroupPermissionId';
/**
 * The interface for defining a permission against a user group
 */
export class CreatePermissionOnGroup {
    constructor(permissionId, restrictedModelType, restrictedModelId) {
        this.permissionId = permissionId;
        this.restrictedModelType = restrictedModelType;
        this.restrictedModelId = restrictedModelId;
    }
    isTopLevelPermission() {
        return this.restrictedModelType === undefined && this.restrictedModelId === undefined;
    }
    isRestrictedPermission() {
        return this.restrictedModelType !== undefined && this.restrictedModelId !== undefined;
    }
}
__decorate([
    IsDefined(),
    IsEnum(UserGroupPermissionId),
    __metadata("design:type", String)
], CreatePermissionOnGroup.prototype, "permissionId", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", String)
], CreatePermissionOnGroup.prototype, "restrictedModelType", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], CreatePermissionOnGroup.prototype, "restrictedModelId", void 0);
